import { Component, OnDestroy, OnInit, Optional } from '@angular/core';
import { HvlAbstractLazyList } from '@hvlng/framework-core/form';
import { HvlFormGroup } from '@hvlng/framework-bff/core';
import { LazyLoadEvent } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
import { UiToastMessageService, UiTranslateLoaderService } from 'ui-shared';
import { PerOrganizationGeneralInfoModel } from '../model/per-organization-general-info-model';
import { OrganizationDefinitionQueryModel } from '../model/organization-definition-query-model';
import { PersonnelSharedService } from '../../../../service/personnel-shared-service';

@Component({
    selector: 'app-organization-selection-list',
    templateUrl: './organization-selection-list.component.html',
})
export class OrganizationSelectionListComponent
    extends HvlAbstractLazyList<PerOrganizationGeneralInfoModel>
    implements OnInit, OnDestroy
{
    selectedModel;
    selectionMode;
    form = new HvlFormGroup<OrganizationDefinitionQueryModel>(new OrganizationDefinitionQueryModel());
    listSubscription: Subscription;
    list;
    pageCode: string;
    isClear: boolean;
    showStaffFullnessStatus: boolean;
    dataKey: string = 'perObjectDefinitionId';
    constructor(
        protected translateService: UiTranslateLoaderService,
        private uiToastMessageService: UiToastMessageService,
        @Optional() public dynamicDialogRef: DynamicDialogRef,
        private service: PersonnelSharedService,

        @Optional() private dialogConfig: DynamicDialogConfig,
    ) {
        super();
    }

    ngOnInit(): void {
        this.list = [];
        this.isClear = false;
        this.selectionMode = this.dialogConfig.data.selectionMode;
        if (this.dialogConfig.data.orgPickerData) {
            this.selectedModel = this.dialogConfig.data.orgPickerData;
        }
        if (this.dialogConfig.data.dataKey) {
            this.dataKey = this.dialogConfig.data.dataKey;
        }
        this.showStaffFullnessStatus = this.dialogConfig.data.showStaffFullnessStatus;
        if (this.dialogConfig.data.queryModel) {
            this.form.patchValue(this.dialogConfig.data.queryModel);
        }
    }

    lazyLoadData(event: LazyLoadEvent) {
        this.loading = true;
        this.preparePageable(event, this.form);
        this.listSubscription = this.service.queryOrganizationPage(this.form.value).subscribe((response) => {
            this.list = response.data;
            this.totalElements = response.totalElements;
            this.totalPages = response.totalPages;
            this.loading = false;
        });
    }

    onRowSelectClickEvent() {
        if (this.selectionMode == 'select-all') {
            if (this.dynamicDialogRef) this.dynamicDialogRef.close(this.form);
        } else {
            if (!this.selectedModel) {
                this.uiToastMessageService.showWarn(this.translateService.instant('toastMessage.chooseDataFromTable'));
            } else {
                if (this.dynamicDialogRef) {
                    this.dynamicDialogRef.close(this.selectedModel);
                } else this.onRowSelectEventEmitter.emit(this.selectedModel[0]);
            }
        }
    }

    ngOnDestroy() {
        if (this.listSubscription) this.listSubscription.unsubscribe();
    }

    onCancel() {
        this.selectedModel = null;
        this.dynamicDialogRef.close();
    }

    onSearch() {
        // this.selectedModel = null;
        this.dataTableRef.reset();
    }

    onClear() {
        this.isClear = true;
        this.form.reset();
        this.form.patchValue(this.dialogConfig.data.queryModel);

        this.onSearch();
    }
}
